// extracted by mini-css-extract-plugin
export default {"input":"InlineEditText__input___teuY3","container":"InlineEditText__container___pSvyQ","text":"InlineEditText__text____fWgx"};